module.exports = __webpack_public_path__ + "img/Ingrid.8266f99b.jpg";